<div class="ds-shell" [class.dss-drawer-open]="openSection">

  <!-- TOP BAR (every resolution): logo left; utilities + profile right -->
  <header class="dss-topbar">
    <a [routerLink]="homeLink" class="dss-logo-link" aria-label="ArtFlow Pro home">
      <img class="dss-logo" [src]="logoSrc"
        onerror="this.onerror=null;this.src='assets/images/thumb_AFP-logo-v02-noTagline-800.png'" alt="ArtFlow Pro">
    </a>
    <div class="dss-top-actions">
      @if (viewingRoleAsAdmin) {
        <a class="dss-back-admin" href="#" (click)="exitToAdmin($event)" title="Back to Admin">
          <i class="fa fa-arrow-left"></i><span class="dss-create-text">Back to Admin</span>
        </a>
      }
      @if (createLink) {
        <a class="dss-create" [routerLink]="createLink">
          <i class="fa fa-plus"></i><span class="dss-create-text">Create</span>
        </a>
      }
      <a class="dss-icon dss-hide-phone" routerLink="/inbox" title="Messages"><i class="fa fa-comments"></i></a>
      <a class="dss-icon" routerLink="/notifications-list" title="Notifications"><i class="fa fa-bell"></i></a>
      <a class="dss-icon" routerLink="/edit-profile" title="Settings"><i class="fa fa-cog"></i></a>
      <div class="dss-profile">
        <button class="dss-avatar" (click)="toggleUserMenu($event)" aria-label="Your account">
          @if (avatarUrl) { <img [src]="avatarUrl" alt=""> } @else { <span>{{ initials() }}</span> }
        </button>
        @if (isUserMenuOpen) {
          <div class="dss-backdrop" (click)="closeUserMenu()"></div>
          <div class="dss-menu" (click)="$event.stopPropagation()">
            <div class="dss-menu-name">{{ firstName }}</div>
            <a routerLink="/edit-profile" (click)="closeUserMenu()"><i class="fa fa-user"></i> My profile</a>
            @if (role === 'gallery') {
              <a routerLink="/gallery-staff" (click)="closeUserMenu()"><i class="fa fa-users"></i> Gallery staff</a>
            }
            <a routerLink="/user-invoice" (click)="closeUserMenu()"><i class="fa fa-receipt"></i> Subscriptions</a>
            <a routerLink="/all-pages" (click)="closeUserMenu()"><i class="fa fa-list"></i> All pages</a>
            <hr>
            <a href="#" class="dss-signout" (click)="logout($event)"><i class="fa fa-sign-out"></i> Sign out</a>
          </div>
        }
      </div>
    </div>
  </header>

  <div class="dss-body">
    <!-- LEFT ICON RAIL (desktop / laptop) -->
    <nav class="dss-rail">
      @for (n of navItems; track n.label) {
        <a class="dss-rail-item"
           [class.active]="isSectionActive(n)"
           [class.expanded]="openSection === n"
           href="#" (click)="onRailClick(n, $event)">
          <i [class]="n.icon"></i><span>{{ n.label }}</span>
        </a>
      }
    </nav>

    <!-- SECONDARY DRAWER (desktop): sub-items of the open rail section -->
    @if (openSection) {
      <aside class="dss-drawer">
        <div class="dss-drawer-head">
          <i [class]="openSection.icon"></i>
          <span class="dss-drawer-title">{{ openSection.label }}</span>
          <button class="dss-drawer-close" (click)="closeDrawer()" aria-label="Close menu"><i class="fa fa-times"></i></button>
        </div>
        <ul class="dss-drawer-list">
          @for (c of openSection.children; track c.label) {
            <li>
              <a [routerLink]="c.link" routerLinkActive="active"
                 [routerLinkActiveOptions]="{ exact: true }">{{ c.label }}</a>
            </li>
          }
        </ul>
      </aside>
    }

    <!-- PAGE CONTENT (the router-outlet lives here, supplied by app.component) -->
    <main class="dss-content">
      <ng-content></ng-content>
    </main>
  </div>

  <!-- BOTTOM BAR (tablet + phone) -->
  <nav class="dss-bottombar">
    @for (n of navItems; track n.label) {
      <a class="dss-bb-item"
         [class.dss-secondary]="!isPrimary(n.label)"
         [class.active]="isSectionActive(n)"
         href="#" (click)="onRailClick(n, $event)">
        <i [class]="n.icon"></i><span>{{ n.label }}</span>
      </a>
    }
    <a class="dss-bb-item dss-more" routerLink="/all-pages"><i class="fa fa-ellipsis-h"></i><span>More</span></a>
  </nav>

</div>
